<template>
  <!-- Phase 2 - Advisory Committee Reports (#28) -->
  <div class="mt-3">
    <div class="d-flex align-items-center mb-3">
      <h3>Advisory Committee - Allocation Audit Report</h3>
      <div class="flex-grow-1"></div>
      <b-button @click="$router.push('/')">Back</b-button>
    </div>
    <b-card class="mb-3">
      <b-row>
        <b-col cols="12" md="3">
          <date-picker
            v-model="filter.from_date"
            label="From Date"
          ></date-picker>
        </b-col>
        <b-col cols="12" md="3">
          <date-picker
            v-model="filter.to_date"
            label="To Date"
          ></date-picker>
        </b-col>
        <b-col cols="12" md="3">
          <select-field
            v-model="filter.organ_id"
            label="Organ"
            :items="organList"
          ></select-field>
        </b-col>
        <b-col cols="12" md="3" class="d-flex align-items-end">
          <b-button variant="primary" class="me-2" @click="fetch"
            >Search</b-button
          >
          <b-button variant="outline-secondary" @click="reset">Reset</b-button>
        </b-col>
      </b-row>
    </b-card>
    <!-- Summary Cards -->
    <b-row class="mb-3" v-if="summary.total_allocations">
      <b-col cols="12" md="3">
        <b-card class="text-center">
          <h4>{{ summary.total_allocations }}</h4>
          <small class="text-muted">Total Allocations</small>
        </b-card>
      </b-col>
      <b-col cols="12" md="3">
        <b-card class="text-center">
          <h4>{{ summary.completed_transplants }}</h4>
          <small class="text-muted">Completed Transplants</small>
        </b-card>
      </b-col>
      <b-col cols="12" md="3">
        <b-card class="text-center">
          <h4>{{ summary.pending_allocations }}</h4>
          <small class="text-muted">Pending Allocations</small>
        </b-card>
      </b-col>
      <b-col cols="12" md="3">
        <b-card class="text-center">
          <h4>{{ summary.rejected_allocations }}</h4>
          <small class="text-muted">Rejected/Skipped</small>
        </b-card>
      </b-col>
    </b-row>
    <!-- Allocation Audit Trail Table -->
    <table-view
      title="Allocation Decisions"
      :fields="fields"
      :isBusy="isLoading"
      :items="list"
    >
      <template v-slot:allocation_status="{ value }">
        <span :class="getStatusClass(value)">{{ getStatusName(value) }}</span>
      </template>
    </table-view>
  </div>
</template>

<script>
import { formatDate } from "../assets/js/common";
import donorService from "../assets/services/donor.service";
import TableView from "../components/table/TableView.vue";
import DatePicker from "../components/form/DatePicker.vue";
import SelectField from "../components/form/SelectField.vue";
import { ALLOCATION_AUDIT_STATUS } from "../assets/constants/committee.constants";
export default {
  components: { TableView, DatePicker, SelectField },
  data() {
    return {
      isLoading: false,
      filter: {
        from_date: "",
        to_date: "",
        organ_id: "",
      },
      list: [],
      summary: {},
      organList: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "sno", label: "S.No" },
        { key: "donor_id", label: "Donor ID" },
        { key: "donor_name", label: "Donor Name" },
        { key: "hospital_name", label: "Hospital" },
        { key: "organ_name", label: "Organ" },
        { key: "recipient_uid", label: "Recipient UID" },
        { key: "recipient_name", label: "Recipient Name" },
        { key: "allocation_date", label: "Allocation Date" },
        { key: "allocation_status", label: "Status" },
        { key: "decision_by", label: "Decision By" },
        { key: "remarks", label: "Remarks" },
      ];
    },
  },
  methods: {
    getStatusName(value) {
      let item = ALLOCATION_AUDIT_STATUS.find((s) => s.value == value);
      return item ? item.name : value;
    },
    getStatusClass(value) {
      switch (String(value)) {
        case "28":
          return "badge bg-success font-size-13";
        case "13":
          return "badge bg-danger font-size-13";
        case "2":
          return "badge bg-info font-size-13";
        default:
          return "badge bg-secondary font-size-13";
      }
    },
    reset() {
      this.filter = { from_date: "", to_date: "", organ_id: "" };
      this.list = [];
      this.summary = {};
    },
    async fetch() {
      const vm = this;
      try {
        vm.isLoading = true;
        vm.list = [];
        let doc = {
          dml_indicator: "COMMITTEE",
          ...vm.filter,
        };
        let { data } = await donorService.organAllocationReport(doc);
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (!status) {
          vm.$alert.show(msg);
          return;
        }
        if (data.summary) {
          vm.summary = data.summary;
        }
        vm.list = (list || []).map((item, i) => {
          item.sno = i + 1;
          item.allocation_date = formatDate(item.allocation_date);
          return item;
        });
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
    async fetchOrgans() {
      const vm = this;
      try {
        let organs = vm.$store.getters.master.master_organ;
        if (organs instanceof Array) {
          vm.organList = organs.map((item) => ({
            name: item.organ_name,
            value: item.organ_id,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.fetchOrgans();
  },
};
</script>
